export const getFundButtons = ({
  isConnected,
  isUploadEnabled,
  disconnectedAt,
  isPrimaryUser
}) => {
  if (isConnected && !isUploadEnabled) return ["SYNC"];

  if (isConnected && isUploadEnabled && !disconnectedAt)
    return ["MANUAL", "SYNC"];

  if (!isConnected && isUploadEnabled && disconnectedAt)
    return ["MANUAL", "LINK"];

  if (!isConnected && !disconnectedAt && isUploadEnabled)
    return isPrimaryUser ? ["MANUAL"] : ["MANUAL", "LINK"];

  if (!isConnected && !isUploadEnabled) return ["LINK"];

  return [];
};

export const parseInvalidInvoiceDateErrors = (message = "") => {
  const regex =
    /Invalid issue date format for invoice number '([^']+)'\. Provided issue date: '([^']+)'\. Expected format: ([^.\n]+)\./g;

  const results = [];
  let match;

  while ((match = regex.exec(message)) !== null) {
    results.push({
      invoiceNumber: match[1],
      issueDate: match[2],
      expectedFormat: match[3]
    });
  }

  return results;
};
